import { ScheduleGridHeaderCellProps } from 'components/ScheduleGrid/ScheduleGrid.Types';

interface IFCTrackerRightHeaderCellProps extends ScheduleGridHeaderCellProps {
  currentHeader: {
    title: string;
  };
}

const IFCTrackerRightHeaderCell = (props: IFCTrackerRightHeaderCellProps) => {
  // console.log('props', props);
  const { currentHeader } = props;
  return (
    <div
      style={{
        border: '1px solid #eee',
        ...props.style,
        ...props.styles,
      }}
    >
      <b>Form {currentHeader?.title}</b>
    </div>
  );
};

export default IFCTrackerRightHeaderCell;
